import { emptyObj } from 'util/objects'
import { selectApplication } from './selectApplication'

export const selectAccount = state =>
  selectApplication(state).account || emptyObj
